
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'VcsConnections',
  props: {
    vcsInstallationUrl: {
      type: String,
      required: true
    },
    vcsProviderDisplay: {
      type: String,
      required: true
    },
    vcsProviderIcon: {
      type: String,
      required: true
    },
    teamName: {
      type: String,
      required: true
    },
    autofixAvailable: {
      type: Boolean,
      default: false
    },
    autofixEnabled: {
      type: Boolean,
      default: false
    },
    autofixInstallationUrl: {
      type: String,
      default: ''
    }
  }
})
